module.exports = "/packs/images/svg/ireland/facilities/leisure_studio~9ed36671e8a579bb9afb9a4155b51789.svg";